import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material'
import { Speed } from '@mui/icons-material'
import AuroraAssetGroupCirculationPumpStatusControl from './AuroraAssetGroupCirculationPumpStatusControl'
import AuroraAssetGroupCirculationPumpModeControl from './AuroraAssetGroupCirculationPumpModeControl'
import AuroraControlGroup from './AuroraControlGroup'
import { AuroraAssetGroup } from '../types'

interface AuroraAssetGroupCirculationPumpControlsProps {
  auroraAssetGroup: AuroraAssetGroup
}

export default function AuroraAssetGroupCirculationPumpControls({
  auroraAssetGroup
}: AuroraAssetGroupCirculationPumpControlsProps) {
  const { t } = useTranslation('aurora')

  const theme = useTheme()

  return (
    <AuroraControlGroup
      label={t('circulationPumpControl')}
      icon={<Speed htmlColor={theme.palette.text.secondary} />}
    >
      {/*<AuroraAssetGroupCirculationPumpStatusControl auroraAssetGroup={auroraAssetGroup} />*/}
      <AuroraAssetGroupCirculationPumpModeControl auroraAssetGroup={auroraAssetGroup} />
    </AuroraControlGroup>
  )
}
